// src/plugins/connection.js
import ConnectorService from '../services/connector.service';

export default {
  install(app) {
    app.config.globalProperties.$conn = ConnectorService;
  }
};
